module.exports = __webpack_public_path__ + "static/media/plate-otkroy.9376da89.png";